/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED EDIT NAME : STYLES --------------- ++++++++++ */
export default theme => ({
	editembedname: {
		maxWidth: pxToEm(432),
        extend: [theme.modal.form],
        '& .gridset': {
        	width: '100% !important'
        },
        '& .assignmentfieldinputfield': {
		    fontSize: pxToEm(16)
        }
    }
});
